var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5295 3.72314H4.61282C3.59372 3.72314 2.76758 4.54929 2.76758 5.56838V18.4851C2.76758 19.5041 3.59372 20.3303 4.61282 20.3303H17.5295C18.5486 20.3303 19.3747 19.5041 19.3747 18.4851V5.56838C19.3747 4.54929 18.5486 3.72314 17.5295 3.72314Z",
    stroke: "#2A3140",
    strokeWidth: 1.38393,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7617 1.88135V5.57182",
    stroke: "#2A3140",
    strokeWidth: 1.38393,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38037 1.88135V5.57182",
    stroke: "#2A3140",
    strokeWidth: 1.38393,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76758 9.26025H19.3747",
    stroke: "#2A3140",
    strokeWidth: 1.38393,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9241cff8d1086fdf3a3cd722627c9e0b.svg";
export { ForwardRef as ReactComponent };